import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type WritingLegendsCatalogueService from 'teacher-ui-client/services/writing-legends-catalogue'

interface Params extends Record<string, unknown> {
  activity_id: string
}
export interface ActivityBlock {
  block_id: string
  content: string
  block_type: string
  lexorank?: string
  question_type?: string
  target_word_count?: number
}
export interface EWIActivity {
  activity_id: string
  title: string
  description: string
  tags?: string
  thumbnail?: string
  template: string
  blocks: ActivityBlock[]
}

export default class EWIPreviewsRoute extends Route {
  @service writingLegendsCatalogue!: WritingLegendsCatalogueService

  async model(params: Params) {
    const activity = await this.writingLegendsCatalogue.fetchData<EWIActivity>(
      this.writingLegendsCatalogue.buildActivityUrl(params.activity_id),
    )
    return {
      params,
      activity,
    }
  }
}
